import { Client } from "@/Common/Api/Client";
import { PatientRefIntervenorWithDetails } from "@/Common/Api/Patient/Dto/PatientRefIntervenorWithDetails";
import { IPharmacyInfo } from "@/Common/Api/Pharmacy/Dto/Responses/IPharmacyInfo";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { ContactDirectoryClient } from "../Api/ContactDirectoryClient";
import { DirectoryEntityType, DirectoryHealthCareProviderSearchDto } from "../Api/medfar-contactdirectory/dist";
import { DirectoryHealthCareProvider } from "../Models/DirectoryHealthCareProvider";
import { PharmacyProxy } from "../Models/PharmacyProxy";

interface LoadPatientPreferredContactInfoResponse {
    PreferredPharmacy: IPharmacyInfo | null;
    DirectoryPharmacyId: string | null;
    IntervenorsOnFile: PatientRefIntervenorWithDetails[];
}

export class PatientContactDirectoryHelper {
    public static async loadPatientPreferredContacts(patientContactId: string): Promise<{ externalConsultants: DirectoryHealthCareProvider[], preferredPharmacy: PharmacyProxy | null } | null> {
        if (!patientContactId)
            return null;

        const response = await Client.postAsync<LoadPatientPreferredContactInfoResponse>(ServerOperations.Server.Myle_Patient_PreferredContacts_Load, { patientContactId });

        if (!response.isSuccess) {
            console.error(response.errors);
            return null;
        }

        const preferredPharmacy = new PharmacyProxy({
            directoryPharmacyId: response.data.DirectoryPharmacyId,
            customPharmacy: { ...response.data.PreferredPharmacy }
        });

        await preferredPharmacy.loadDirectoryPharmacy();

        const externalConsultants = response.data.IntervenorsOnFile?.map(p => new PatientRefIntervenorWithDetails(p));

        const healthCareProviders: DirectoryHealthCareProviderSearchDto[] = await ContactDirectoryClient.getInstance()
            .getByIds(
                DirectoryEntityType.HealthcareProvider,
                externalConsultants.map(p => p.Intervenor.HealthCareProviderId).filter(p => !!p)
            );

        externalConsultants.forEach(externalConsultant => {
            externalConsultant.HealthCareProvider = healthCareProviders.firstOrDefault(p => p.id === externalConsultant.Intervenor.HealthCareProviderId);
        });

        return {
            externalConsultants: externalConsultants
                .filter(p => !!p.HealthCareProvider)
                .map(p => DirectoryHealthCareProvider.fromPatientRefIntervenor(p)),
            preferredPharmacy: preferredPharmacy
        };
    }
}
